// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3IdLv","content":"RecentSearches_content__2vvbd"};